import './OkulyonetimFavorite.scss';

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useFavorilerQuery } from '../../../gql/GeneratedGraphqlTypes';
import Spinner from '../../spinner/Spinner';
import OkulyonetimProduct from '../okulyonetim-product/OkulyonetimProduct';

const OkulyonetimFavorite = () => {
  const navigate = useNavigate();
  const { data, loading, error, refetch } = useFavorilerQuery({}); // refetch dahil

  // İlk yüklemede refetch çağrısı
  useEffect(() => {
    const fetchFavorites = async () => {
      await refetch();
    };
    fetchFavorites();
  }, [refetch]); // Sadece refetch değiştiğinde tetiklenir

  if (loading) {
    return <Spinner showSpinner={loading} color="red" />;
  }
  if (error) {
    console.error(error);
    navigate('/');
  }

  const handleFavoriteChange = async () => {
    // Favori değişikliği sonrası listeyi yenile
    await refetch();
  };

  const products = data?.profil?.favori_urunler?.map((product) => (
      <OkulyonetimProduct
          key={product?.urun?.id}
          image={product?.urun?.resim || product?.urun?.resim_url!}
          title={product?.urun?.isim || ''}
          pdf_url={product?.urun?.pdf_url}
          pdf={product?.urun?.pdf}
          id={product?.urun?.id || 1}
          price={product?.urun?.etiket_fiyati!}
          mufredat={product?.urun?.mufredat ? product.urun.mufredat : false}
          oneri={product?.urun?.oneri ? product.urun.oneri : false}
          quantity={1}
          initialIsFavori={product?.urun?.is_favori ? product.urun.is_favori : false}
          onFavoriteChange={handleFavoriteChange} // Favori değişikliğini tetikle
      />
  ));

  return (
      <div className="db-okulyonetim-favorite">
        <h2>Favorilerim</h2>
        <div className="okulyonetim-favorites">{products}</div>
      </div>
  );
};

export default OkulyonetimFavorite;
